/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ArchDevianceService {

  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  /**
   * Sends a get request to get all the architectures in a Program Code
   * @param prgmCode program code
   */
  getArchByProgramCode(prgmCode: string): Observable<any> {
    const params = new HttpParams().set('prgmcode', prgmCode);
    return this.http.get<any>(`${this.configService.baseApiUrl}manage-arch-deviance`, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Return a list of any non-compliant program code.
   */
  getNonCompliantProgramCodes(): Observable<any> {
    return this.http.get<any>(`${this.configService.baseApiUrl}manage-arch-deviance/non-compliant-program-codes`)
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Sends a request to update the arch values for a program code in the Vehicle Portfolio table,
   * Vehicle Scenario Detail table, and the Program Code table
   *
   * @param prgmCode
   * @param arch
   */
  updateArchDeviances(prgmCode: string, arch: string): Observable<any> {
    const params = new HttpParams().set('prgmcode', prgmCode).set('arch', arch);
    return this.http.put<any>(`${this.configService.baseApiUrl}manage-arch-deviance`, null, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   */
  private handleError(errorResponse: HttpErrorResponse): Observable<any> {
    let errorMessage = 'An unexpected error has occurred.';
    if (errorResponse.error && errorResponse.error.message) {
      errorMessage = errorResponse.error.message;
    }
    return throwError(errorMessage);
  }

}
